import { request } from "apis/base";
import { CommonParamsType } from "constants/types/common";
import { BankAccountCreateBodyType, BankAccountUpdateBodyType } from "constants/types/bankAccount";

export const bankAccountApi = {
  getAll: (params?: CommonParamsType) => {
    return request({ url: "/bank-account", method: "GET", params });
  },

  getById: (id: string) => {
    return request({ url: `/bank-account/${id}`, method: "GET" });
  },

  create: (data: BankAccountCreateBodyType) => {
    return request({ url: "/bank-account", method: "POST", data });
  },

  update: (id: string, data: BankAccountUpdateBodyType) => {
    return request({ url: `/bank-account/${id}`, method: "PUT", data });
  },

  delete: (id: string) => {
    return request({ url: `/bank-account/${id}`, method: "DELETE" });
  },
};
